import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAudits, clearAuditList, saveAudit, deleteAudit, filterAuditListStatus } from 'actions/EntityActions';
import { getCsvReport } from 'actions/ReportsAction';
import WithRouter from 'custom/withRouter';
import LOOKUP from 'constants/lookup';
import { auditListCrumb } from 'utils/breadcrumbInfo';
import { mapAuditList } from 'utils/mappers';
import util from 'library/util';
import { selectInventoryAuditModel } from 'selectors/entitySelector';
// Basic Components
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class InventoryAuditList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: 1,
      itemsPerPage: 25,
      value: 'Active',
      status: 'Active',
      orderBy: "DESC",
      sortBy: "",
      createDialogOpen: false,
      openDeleteDialog: false,
      selectedItem: 0
    };

    this.sort = this.sort.bind(this);
  }

  componentDidMount() {
    this.getAudits(1);
  }

  componentWillReceiveProps(newProps) {
    if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
      this.saveSuccess(newProps.createdAuditId);
    }
  }

  componentWillUnmount() {
    this.props.clearAuditList();
  }

  saveSuccess = (createdId) => {
    this.props.navigate(`/inventoryaudit/${createdId}`);
  }

  changePage = e => {
    this.setState(pState => {
      return {
        ...pState,
        activePage: e
      };
    }, this.getAudits);
  }

  getAudits = (page) => {
    const model = {
      branchId: this.props.branchId,
      page: page || this.state.activePage,
      itemsPerPage: this.state.itemsPerPage,
      orderBy: this.state.orderBy,
      sortBy: this.state.sortBy
    };
    this.props.getAudits(model);
  }

  sort(sortBy) {
    this.setState(prevState => {
      return {
        ...prevState,
        orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
        sortBy: sortBy
      }
    }, this.getAudits);
  }

  openCreateAuditDialog = () => {
    this.setState({ createDialogOpen: true });
  }

  closeCreateAuditDialog = () => {
    this.setState({ createDialogOpen: false });
  }

  saveAudit = () => {
    let audit = this.props.inventoryAuditModel;

    const validators = [
      [`InventoryAuditTitleName`, audit => (audit.Name && audit.Name !== null && audit.Name !== ""), "Inventory Audit Name"]
    ];

    if (!util.validate(validators, audit, this.props.formError)) {
      alert("Please enter a Name");
      return;
    }

    audit.Id = 0;
    audit.branchId = this.props.branchId;
    this.props.saveAudit(audit);
  }

  handleFilterChange = (value) => {
    const selected = value;
    const model = {
      branchId: this.props.branchId,
      page: this.state.activePage,
      itemsPerPage: this.state.itemsPerPage,
      orderBy: this.state.orderBy,
      sortBy: this.state.sortBy,
      Status: selected
    };
    this.props.filterAuditListStatus(model);
    this.setState({ status: selected });
  };

  toggleOpenDialog = () => {
    this.setState((prevState) => ({ ...prevState, openDeleteDialog: !prevState.openDeleteDialog }))
  }

  getSelectedId = (id) => {
    this.setState({ selectedItem: id })
  }
  downloadCsv = (auditId) => {
    let branchId = this.props.branchId;

    this.props.getCsvReport(`audit/download?branchId=${branchId}&AuditId=${auditId}`, `audit${auditId}`);
  }


  render() {
    const p = this.props;
    const s = this.state;
    let audits = this.props.audits ? this.props.audits : [];
    const auditDeleteModel = {
      branchId: this.props.branchId,
      page: 1,
      itemsPerPage: this.state.itemsPerPage,
      orderBy: this.state.orderBy,
      sortBy: this.state.sortBy
    }
    return (
      <Grid headerContent={auditListCrumb}>
        <PageHeaderWithButton title={LOOKUP.inventoryAudit.listTitle}>
          <Button
            type="AddButton"
            mini={true}
            id="buttonAddNewAudit"
            label="ADD NEW AUDIT"
            className="bg-light-green"
            onTouchTap={() => this.openCreateAuditDialog()} />
        </PageHeaderWithButton>
        <CardSimple>
          <div className="row">
            <div className="col-xs-12 col-md-6 col-xl-3">
              <SelectInput
                name={"status"}
                fullWidth={true}
                floatingLabelText={"status"}
                hintText={"status"}
                value={this.state.status}
                onChange={this.handleFilterChange}
                options={[
                  { value: "0", text: "All" },
                  { value: "1", text: "Pending" },
                  { value: "2", text: "Completed" }
                ]}
                defaultValue="0"
              />
            </div>
          </div>
        </CardSimple>
        <CardSimple>
          <GenericTable
            className="table_center"
            tableBodyClassName="campaigns-table"
            multiSelectable={false}
            enableSelectAll={false}
            selectable={false}
            columns={LOOKUP.inventoryAudit.listTableColumns}
            rows={mapAuditList(audits, p.canManageAudit, this.toggleOpenDialog, this.getSelectedId, this.downloadCsv)}
            orderBy={this.state.orderBy}
            sortBy={this.state.sortBy}
            sort={this.sort}
            stripedRows={true}
          />
          <Pagination
            length={audits != null && audits[0] != null ? audits[0].totalRows : 0}
            itemsPerPage={s.itemsPerPage}
            activePage={s.activePage}
            onPageChange={this.changePage}
            maxButtons={8} />
        </CardSimple>
        <DialogInput
          title={<DialogHeaderWithClose text="Create Inventory Audit" handleClose={() => this.closeCreateAuditDialog()}/>}
          actions={[
            <Button
              key={1}
              type="CancelButton"
              name="buttonCancel"
              className="btn-space"
              label={LOOKUP.common.cancel.text}
              onTouchTap={() => this.closeCreateAuditDialog()} />,
            <Button
              key={2}
              name="ConfirmButton"
              label={LOOKUP.common.confirm.text}
              primary={true}
              onTouchTap={() => this.saveAudit()} />]}
          modal={true}
          open={this.state.createDialogOpen}>
            <div className="row">
              <div className='col-lg-12'>
                <p>Please specify the name of the inventory audit</p>
              </div>
            </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <TextInput
                name={`InventoryAuditTitleName`}
                fullWidth={true}
                label={"Inventory Audit Name"}
                floatingLabelText={"Inventory Audit Name"}
                hintText={"Inventory Audit Name"}
                className="InventoryAuditName" />
            </div>
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 mt-3">
              <ToggleInput
                className="btnToggleLabel"
                fullWidth={true}
                name={`InventoryAuditLockExpectedQuantity`}
                label={"Lock Expected Quantity (Not Recommended)"}
                option1={''}
                option2={''}
              />
            </div>
          </div>

        </DialogInput>
        <DialogInput
          title={
            <div className="modal-title noPadding mb-2">
              <div className={`chartHeaderBar posDialogClassic`}>
                <div className={`chartbgColor posDialogClassic`}>
                  <span className="whiteFontColor">CONFIRM DELETE</span>
                  <div className="bg-svg">
                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
                      <rect className="sideZero" width="40" height="40" />
                      <path className="sideOne" d="M0,0v40h1.45L26.44,6.73C29.55,2.65,34.87,0,40,0H0z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          }
          modal={true}
          open={s.openDeleteDialog}
          autoScrollBodyContent={true}
          style={{ zIndex: "950" }}
          actions={[
            <Button
              key={1}
              name="CancelButton"
              label="Cancel"
              primary={true}
              className="btn-space-20"
              onTouchTap={() => this.toggleOpenDialog()}
            />,
            <Button
              key={2}
              name="ConfirmDelete"
              label="Delete"
              primary={true}
              className="btn-space-20"
              onTouchTap={() => { p.deleteAudit(auditDeleteModel, p.branchId, s.selectedItem); this.toggleOpenDialog(); }}
            />
          ]}
          contentStyle={{ width: "65%" }}
        >
          <div>
            <div className="row">
              <div className="col-lg-12">
                <h4 className="purpleText">
                  Are you sure you wish to delete this audit? Deleting this audit will permanently remove it from history.
                </h4>
              </div>
            </div>
          </div>
        </DialogInput>
      </Grid>

    );
  }
}

function mapStatetoProps(state) {
  return {
    branchId: state.common.branchId,
    audits: state.entity.inventoryAudits,
    inventoryAudit: state.entity.inventoryAudit,
    inventoryAudits: state.entity.inventoryAudits,
    inventoryAuditModel: selectInventoryAuditModel(state, "InventoryAudit"),
    canManageAudit: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanManageAudit")),
    saveSuccess: state.form["InventoryAuditSaveTimeStamp"],
    createdAuditId: state.form["InventoryAuditCreatedId"]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAudits: (model) => dispatch(getAudits(model)),
    clearAuditList: () => dispatch(clearAuditList()),
    saveAudit: (model) => dispatch(saveAudit(model)),
    deleteAudit: (model, branchId, itemId) => dispatch(deleteAudit(model, branchId, itemId)),
    filterAuditListStatus: (model) => dispatch(filterAuditListStatus(model)),
    getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(InventoryAuditList));
